import React, { useState } from 'react'
import styled from "styled-components";
import moment from "moment";
import { connect } from 'react-redux'
import { Icon, Row, Col, Collapse, Card, Tooltip, Modal, Layout } from 'antd'
import PropTypes from 'prop-types'
import typo, { MESSAGE } from "../../../constants/dictionaries";
import Select from '../../../components/Common/Select'
import Button from '../../../components/Buttons'
import { FastField } from "formik";
import ValidatedText from "../../../components/Common/ValidatedText";
import helper from '../../../helper/helper'
import Input from '../../../components/Common/Input'
import Api from '../../../api';
import message from "../../../components/Messages";
import constant, { functionsCode } from '../../../constants/constant'
import Container from "../../../containers/Container";
import PageWrapper from "../../../components/Common/PageWrapper";
import { isEmpty } from 'lodash';
import Api_quantrac from '../../../api/api.quantrac';
import Api_tnn from '../../../api/api.tnn';
import SearchByURI from "../../../helper/SearchByURI";
import Api_dms from '../../../api/api.dms';
import BCDKModal from "../../DTM/BaoCaoDinhKy/Modal/BCDKModal"
import BCDKBVMTModal from "../../BaoVeMoiTruong/BaoCaoDinhKy/Modal/BCDKModal"
import EditOrAddModal from "../../ThanhTraKiemTra/QuyetDinhXuPhatViPham/Modal/BCDKModal"
import DNBCTNNModal from "../../licenses/BaoCaoDinhKy/Modal/DNBCModal"
import Status from "../../../components/Table/Status";
import StatusQT from "../../../components/Table/Status/QuanTracStatus";
const { Content, Footer } = Layout;
const { Panel } = Collapse;
const { Meta } = Card;
let timeout;
let currentValue;
const TitleWrapper = styled.div`
  background-color: #fff;
  padding: 8px 16px;
`;
const CustomIcon = styled(Icon)`
  font-size: 16px;
  cursor: pointer;
  color: ${props => props.color} !important;
`;
function fetch(value, callback, user) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;
  if (value === "null") {
    callback([]);
  } else {
    function fake() {
      new Api().Get_DonViXinCapPheps_paged({ token: user.access_token, page: 0, size: 0, strSearch: currentValue })
        .then(res => {
          if (currentValue === value) {
            callback(res && res.data);
          }
        })
        .catch((err) => message.error(err.message))
    }
    timeout = setTimeout(fake, 800);
  }
}
class TimKiemDoanhNghiep extends React.PureComponent {
  constructor(props) {
    super(props);
    const { functions } = props;
    this.state = {
      data: [],
      dataDTM: [],
      dataBVMT: [],
      dataTTKT: [],
      dataGP: [],
      searchDoanhNghiep: [],
      selectedRow: undefined,
      timeout: null,
      isShowEditDTMModal: false,
      isShowEditBVMTModal: false,
      isShowEditQDXPModal: false,
      isShowEditTNNModal: false,
      list_MT: {},
      editable: !isEmpty(functions) ? helper.handleGetEditableFunction(functions, functionsCode.TKDN).editable : false,
    };
    this.searchParams = {
      idDoanhNghiep: undefined,
    };

    this.searchByURI = new SearchByURI({ defaultParams: this.searchParams });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps !== this.props) {
      const { functions } = this.props;
      if (!isEmpty(functions)) {
        const func = helper.handleGetEditableFunction(functions, functionsCode.TKDN);
        this.setState({ editable: func.editable })
      }
    }
  }
  componentDidMount = () => {
    const searchParams = this.searchByURI.getSearchParmas();
    if (searchParams.idDoanhNghiep) {
      this.setState({
        searchDoanhNghiep: JSON.parse(searchParams.idDoanhNghiep)
      })
      this.GetDSDuLieuByIDDoanhNghiep(JSON.parse(searchParams.idDoanhNghiep))
      this.GetGpByDoanhNghiep(JSON.parse(searchParams.idDoanhNghiep))
      this.getDVXCP("", JSON.parse(searchParams.idDoanhNghiep))
    }
  }

  getDVXCP = (strSearch, idDoanhNghiep) => {
    const { user } = this.props
    new Api().Get_DonViXinCapPheps_paged({ token: user.access_token, page: 0, size: 0, strSearch: strSearch })
      .then(res => {
        if (idDoanhNghiep) {
          let data_doanhnghiep = []
          idDoanhNghiep.length > 0 && idDoanhNghiep.map((vl, idx) => {
            let obj = res && res.data.find(e => e.id === vl);
            data_doanhnghiep.push(obj)
          })
          this.setState({ data: data_doanhnghiep.map((item) => ({ ...item, tenvsdiachi: item.ten + ". Địa chỉ: " + item.diaChi })) })
        } else {
          this.setState({ data: res && res.data.map((item) => ({ ...item, tenvsdiachi: item.ten + ". Địa chỉ: " + item.diaChi })) })
        }
      })
      .catch((err) => message.error(err.message))
  }
  downFileExcel = () => {

    const searchParams = this.searchByURI.getSearchParmas();
    new Api_quantrac().DownloadFileTraCuuDoanhNghiep({
      token: this.props.user.access_token,
      strSearch: searchParams.StrSearch,
      dulieu_doanhnghiep: { ...this.state.list_MT, list_TNN: this.state.dataGP }

    })
  }

  GetDSDuLieuByIDDoanhNghiep = (iddoanhnghiep) => {
    const { user } = this.props
    new Api_quantrac().GetDSDuLieuByIDDoanhNghiep({ token: user.access_token, iddoanhnghiep: iddoanhnghiep })
      .then(res => {
        this.setState({
          dataDTM: res.list_DTM ? res.list_DTM : [],
          dataBVMT: res.list_BVMT ? res.list_BVMT : [],
          dataTTKT: res.list_QDXP ? res.list_QDXP : [],
          list_MT: res
        })
      })
      .catch((err) => message.error(err.message))
  }

  GetGpByDoanhNghiep = (iddoanhnghiep) => {
    const { user } = this.props
    new Api_tnn().GetGpByDoanhNghieps({ token: user.access_token, iddoanhnghiep: iddoanhnghiep, madvhc: "1000" })
      .then(res => {
        this.setState({
          dataGP: res
        })
      })
      .catch((err) => message.error(err.message))
  }

  GetDTM_BaoCaoDinhKy = (id) => {
    return new Api_quantrac()
      .GetDTM_BaoCaoDinhKy({
        token: this.props.user.access_token,
        id: id,
      })
      .then((res) => {
        this.setState({
          isShowEditDTMModal: true,
          selectedRow: res,
        });
      }).catch(err => {
        message.error(err.message)
      });
  };
  GetBVMT_BaoCaoDinhKy = (id) => {
    return new Api_quantrac()
      .GetBVMT_BaoCaoDinhKy({
        token: this.props.user.access_token,
        id: id,
      })
      .then((res) => {
        this.setState({
          isShowEditBVMTModal: true,
          selectedRow: res,
        });
      }).catch(err => {
        message.error(err.message)
      });
  };
  GetTT_QDXP = (id) => {
    return new Api_quantrac()
      .GetTT_QDXP({
        token: this.props.user.access_token,
        id: id,
      })
      .then((res) => {
        this.setState({
          isShowEditQDXPModal: true,
          selectedRow: res,
        });
      }).catch(err => {
        message.error(err.message)
      });
  };
  GetDoanhNgiep_BaoCao = (id) => {
    return new Api_tnn()
      .GetDoanhNgiep_BaoCao({
        token: this.props.user.access_token,
        id: id,
      })
      .then((res) => {
        this.setState({
          isShowEditTNNModal: true,
          selectedRow: res,
        });
      }).catch(err => {
        message.error(err.message)
      });
  };
  handleCancel = () => {
    this.setState({
      selectedRow: undefined,
      isShowEditDTMModal: false,
      isShowEditBVMTModal: false,
      isShowEditQDXPModal: false,
      isShowEditTNNModal: false
    })
  }
  SelectSearch = value => {
    const { user } = this.props;
    if (value && value !== "" && value !== undefined) {
      fetch(
        value,
        res => this.setState({ data: res.map((item) => ({ ...item, tenvsdiachi: item.ten + ". Địa chỉ: " + item.diaChi })) }),
        user
      );
    } else {
      fetch(
        "null",
        res => this.setState({ data: res }),
        user
      );
    }
  };
  giayPhep = (value, nhomCT, loaiCT) => {
    if (nhomCT === constant.DICT_NHOM_CT.XT) {
      this.props.history.push(`/tai-nguyen-nuoc/xa-thai/edit/${value}`)
    } else if (nhomCT === constant.DICT_NHOM_CT.NM) {
      this.props.history.push(`/tai-nguyen-nuoc/khai-thac-nuoc-mat/edit/${value}`)
    } else if (nhomCT === constant.DICT_NHOM_CT.NB) {
      this.props.history.push(`/tai-nguyen-nuoc/khai-thac-nuoc-bien/edit/${value}`)
    } else {
      if (loaiCT === constant.DICT_LOAI_CT.NDD_THAMDO) {
        this.props.history.push(`/tai-nguyen-nuoc/tham-do-nuoc-duoi-dat/edit/${value}`)
      } else if (loaiCT === constant.DICT_LOAI_CT.NDD_KHAITHAC) {
        this.props.history.push(`/tai-nguyen-nuoc/khai-thac-nuoc-duoi-dat/edit/${value}`)
      }
    }

  }
  searchDoanhNghiep = (value) => {
    this.searchByURI.navigate({
      idDoanhNghiep: JSON.stringify(value),
    })
  }
  showFile = (data) => {
    if (data.length > 0) {
      new Api_dms().DownloadFile({
        token: this.props.user.access_token,
        data: { oid: data[0].idFile, filename: data[0].tenTaiLieu }
      })
    } else {
      message.warning(MESSAGE.CSCORE_KHONG_CO_FILE)
    }
  }
  render() {
    const { data, dataDTM, dataBVMT, dataTTKT, dataGP, isShowEditTNNModal, isShowEditQDXPModal, isShowEditDTMModal, isShowEditBVMTModal, selectedRow, searchDoanhNghiep } = this.state;
    const { user } = this.props;
    const searchParams = this.searchByURI.getSearchParmas();
    return (
      <PageWrapper title={typo.cscore_title_tcnd}>
        <Container>
          <div>
            <Row type="flex" justify="center">
              <Col xs={24} sm={24} md={12}>
                <Layout className='pagewrapper-layout'>
                  <div className='pagewrapper-layout-container'>
                    <TitleWrapper className='layout-container-title'>
                      <div style={{ textAlign: "center" }}>TRA CỨU DỮ LIỆU CỦA DOANH NGHIỆP/ TỔ CHỨC</div>
                    </TitleWrapper>
                    <Content className='layout-container-content' style={{ minHeight: 0 }}>
                      <Select
                        placeholder="Nhập tên/ địa chỉ để tìm kiếm..."
                        width="100%"
                        name="tenvsdiachi"
                        name_value="id"
                        mandatory={false}
                        defaultValue={searchParams.idDoanhNghiep ? JSON.parse(searchParams.idDoanhNghiep) : undefined}
                        onSearch={this.SelectSearch}
                        onChange={(value, e) => this.setState({ searchDoanhNghiep: value })}
                        showArrow={false}
                        filterOption={false}
                        defaultActiveFirstOption={false}
                        notFoundContent={null}
                        dataSource={data}
                        size="large"
                        modeSelect="multiple"
                      />
                      <div style={{ color: "#aba2a2", marginTop: "10px" }}>Ví dụ: Nhập từ khóa "xi măng hạ long" để tìm kiếm "Công ty cổ phần xi măng Hạ Long"</div>

                      <div className="mt-10" />
                      <Button
                        type="submit"
                        style={{ marginTop: 10, marginLeft: "35%" }}
                        onClick={() => this.searchDoanhNghiep(searchDoanhNghiep)}>
                        <Icon type="search" style={{ marginLeft: '0px' }} />Tìm kiếm</Button>


                      <Button
                        style={{ marginLeft: "1%" }}
                        type="primary" type="excel"
                        onClick={() => this.downFileExcel()}
                      >
                        <Icon type="file-excel" />
                        {typo.cscore_out_excel}
                      </Button>

                    </Content>
                  </div>
                </Layout>
              </Col>
            </Row>
            <hr />
            <Row className="mt-20" />
            <Row>
              {dataDTM.length > 0 &&
                <div>
                  <Collapse bordered={false} defaultActiveKey={['1']}>
                    <Panel header={typo.cscore_dtm} key="1">
                      {dataDTM.map((item, index) => {
                        return <Row>
                          <Col xs={24} md={16}>
                            <div style={{ padding: "10px" }}>
                              <div style={{ margin: "0 0 0 20px" }}>
                                <div onClick={() => { this.props.history.push(`/DTM/bao-cao-phe-duyet/edit/${item.id}`) }}>

                                  {window.innerWidth < 500 ?
                                    <div className="ant-card-meta-title">
                                      <a>{"Số QĐ: " + item.soQD}</a>
                                      <div>
                                        <a>{"Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}</a>
                                      </div>
                                    </div>
                                    :
                                    <div className="ant-card-meta-title">
                                      <a>{"Số QĐ: " + item.soQD + ", Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}</a>
                                    </div>
                                  }

                                  <div className="ant-card-meta-description">
                                    {"Tên dự án: " + item.duAn.tenDuAn}
                                  </div>
                                  {item.duAn.diaChi &&
                                    <div className="ant-card-meta-description">
                                      {"Địa chỉ: " + item.duAn.diaChi}
                                    </div>}
                                  {/* <div className="ant-card-meta-description">
                                {"Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}
                              </div> */}
                                </div>
                                <Tooltip placement="top" title="Xem file" className="ant-card-meta-description">
                                  <CustomIcon
                                    color="#63c2de"
                                    type="file-pdf"
                                    onClick={() => { item.files && this.showFile(item.files) }}
                                    style={{ padding: "5px 10px 0 2px" }}
                                  />
                                </Tooltip>
                                <StatusQT trangthai={item.trangThai} />
                                {item.list_BCDK.length > 0 &&
                                  <Collapse bordered={false}>
                                    <Panel header={typo.cscore_ds_bcdk}>
                                      {item.list_BCDK.map((v, idx) => {
                                        return <Row>
                                          <Col xs={24} md={16}>
                                            <div style={{ padding: "10px" }}>
                                              <div style={{ margin: "0 0 8px 20px" }}>
                                                <div onClick={() => this.GetDTM_BaoCaoDinhKy(v.id)}>
                                                  {window.innerWidth < 500 ?
                                                    <div className="ant-card-meta-title" style={{ fontSize: "14px" }}>
                                                      <a>{"Đợt báo cáo: " + v.dotBaoCao}</a>
                                                      <div>
                                                        <a>{"Kỳ báo cáo: " + v.kyBaoCao}</a>
                                                      </div>
                                                    </div>
                                                    :
                                                    <div className="ant-card-meta-title" style={{ fontSize: "14px" }}>
                                                      <a>{"Đợt báo cáo: " + v.dotBaoCao + ", " + "Kỳ báo cáo: " + v.kyBaoCao}</a>
                                                    </div>
                                                  }

                                                  <div className="ant-card-meta-description" style={{ fontSize: "13px" }}>
                                                    {"Số báo cáo: " + v.ma}
                                                  </div>
                                                  <div className="ant-card-meta-description" style={{ fontSize: "13px" }}>
                                                    {"Tên báo cáo: " + v.ten}
                                                  </div>
                                                </div>
                                                <Tooltip placement="top" title="Xem file" className="ant-card-meta-description">
                                                  <CustomIcon
                                                    color="#63c2de"
                                                    type="file-pdf"
                                                    onClick={() => { v.files_BCDK && this.showFile(v.files_BCDK) }}
                                                    style={{ padding: "5px 2px 0 2px" }}
                                                  />
                                                </Tooltip>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      })}
                                    </Panel>
                                  </Collapse>}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      }
                      )}
                    </Panel>
                  </Collapse>
                  <hr />
                  <Row className="mt-20" />
                </div>
              }
              {/* Bảo vệ môi trường */}

              {dataBVMT.length > 0 &&
                <div>
                  <Collapse bordered={false} defaultActiveKey={['2']}>
                    <Panel header={typo.cscore_bao_ve_moi_truong} key="2">
                      {dataBVMT.map((item, index) => {
                        return <Row>
                          <Col xs={24} md={16}>
                            <div style={{ padding: "10px" }}>
                              <div style={{ margin: "0 0 0 20px" }}>
                                <div onClick={() => { this.props.history.push(`/bao-ve-moi-truong/de-an-chi-tiet/edit/${item.id}`) }}>
                                  {window.innerWidth < 500 ?
                                    <div className="ant-card-meta-title">
                                      <a>{"Số QĐ: " + item.soQD}</a>
                                      <div>
                                        <a>{"Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}</a>
                                      </div>
                                    </div>
                                    :
                                    <div className="ant-card-meta-title">
                                      <a>{"Số QĐ: " + item.soQD + ", Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}</a>
                                    </div>
                                  }

                                  <div className="ant-card-meta-description">
                                    {"Tên dự án: " + item.duAn.tenDuAn}
                                  </div>
                                  {item.duAn.diaChi &&
                                    <div className="ant-card-meta-description">
                                      {"Địa chỉ: " + item.duAn.diaChi}
                                    </div>}
                                </div>
                                <Tooltip placement="top" title="Xem file" className="ant-card-meta-description">
                                  <CustomIcon
                                    color="#63c2de"
                                    type="file-pdf"
                                    onClick={() => { item.files && this.showFile(item.files) }}
                                    style={{ padding: "5px 10px 0 2px" }}
                                  />
                                </Tooltip>
                                <StatusQT trangthai={item.trangThai} />
                                {item.list_BCDK.length > 0 &&
                                  <Collapse bordered={false}>
                                    <Panel header={typo.cscore_ds_bcdk}>
                                      {item.list_BCDK.map((v, idx) => {
                                        return <Row>
                                          <Col xs={24} md={16}>
                                            <div style={{ padding: "10px" }}>
                                              <div style={{ margin: "0 0 8px 20px" }}>
                                                <div onClick={() => this.GetBVMT_BaoCaoDinhKy(v.id)}>
                                                  {window.innerWidth < 500 ?
                                                    <div className="ant-card-meta-title" style={{ fontSize: "14px" }}>
                                                      <a>{"Đợt báo cáo: " + v.dotBaoCao}</a>
                                                      <div> <a>{"Kỳ báo cáo: " + v.kyBaoCao}</a></div>
                                                    </div>
                                                    :
                                                    <div className="ant-card-meta-title" style={{ fontSize: "14px" }}>
                                                      <a>{"Đợt báo cáo: " + v.dotBaoCao + ", " + "Kỳ báo cáo: " + v.kyBaoCao}</a>
                                                    </div>
                                                  }

                                                  <div className="ant-card-meta-description" style={{ fontSize: "13px" }}>
                                                    {"Số báo cáo: " + v.ma}
                                                  </div>
                                                  <div className="ant-card-meta-description" style={{ fontSize: "13px" }}>
                                                    {"Tên báo cáo: " + v.ten}
                                                  </div>
                                                </div>
                                                <Tooltip placement="top" title="Xem file" className="ant-card-meta-description">
                                                  <CustomIcon
                                                    color="#63c2de"
                                                    type="file-pdf"
                                                    onClick={() => { v.files_BCDK && this.showFile(v.files_BCDK) }}
                                                    style={{ padding: "5px 2px 0 2px" }}
                                                  />
                                                </Tooltip>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      })}
                                    </Panel>
                                  </Collapse>}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      }
                      )}
                    </Panel>
                  </Collapse>
                  <hr />
                  <Row className="mt-20" />
                </div>}

              {dataTTKT.length > 0 &&
                <div>
                  <Collapse bordered={false} defaultActiveKey={['3']}>
                    <Panel header={typo.cscore_quyet_dinh_xu_phat_vi_pham + " (" + typo.cscore_ttkt + ")"} key="3">
                      {dataTTKT.map((item, index) => {
                        return <div style={{ padding: "10px" }}>
                          <div style={{ margin: "0 0 0 20px" }}>
                            <div onClick={() => this.GetTT_QDXP(item.id)}>
                              {window.innerWidth < 500 ?
                                <div className="ant-card-meta-title">
                                  <a>{"Số QĐ: " + item.soQD}</a>
                                  <div><a>{"Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}</a></div>
                                </div>
                                :
                                <div className="ant-card-meta-title">
                                  <a>{"Số QĐ: " + item.soQD + ", Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}</a>
                                </div>
                              }

                              <div className="ant-card-meta-description">
                                {"Tên doanh nghiệp: " + item.doanhNghiep_Ten}
                              </div>
                              {item.doanhNghiep_DiaChi &&
                                <div className="ant-card-meta-description">
                                  {"Địa chỉ: " + item.doanhNghiep_DiaChi}
                                </div>}
                              {/* <div className="ant-card-meta-description">
                            {"Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}
                          </div> */}
                            </div>
                            <Tooltip placement="top" title="Xem file" className="ant-card-meta-description">
                              <CustomIcon
                                color="#63c2de"
                                type="file-pdf"
                                onClick={() => { item.files && this.showFile(item.files) }}
                                style={{ padding: "5px 10px 0 2px" }}
                              />
                            </Tooltip>
                          </div>
                        </div>
                      }
                      )}
                    </Panel>
                  </Collapse>
                  <hr />
                  <Row className="mt-20" />
                </div>}

              {dataGP.length > 0 &&
                <div>
                  <Collapse bordered={false} defaultActiveKey={['4']}>
                    <Panel header={typo.cscore_tai_nguyen_nuoc} key="4">
                      {dataGP.map((item, index) => {
                        return <Row>
                          <Col xs={24} md={16}>
                            <div style={{ padding: "10px" }}>
                              <div style={{ margin: "0 0 0 20px" }}>
                                <div onClick={() => this.giayPhep(item.id, item.nhomCongTrinh, item.loaiCongTrinh)}>
                                  {window.innerWidth < 500 ?
                                    <div className="ant-card-meta-title">
                                      <a>{"Số giấy phép: " + item.soVanBan}</a>
                                      <div><a>{"Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}</a></div>
                                    </div>
                                    :
                                    <div className="ant-card-meta-title">
                                      <a>{"Số giấy phép: " + item.soVanBan + ", Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}</a>
                                    </div>
                                  }

                                  <div className="ant-card-meta-description">
                                    {"Tên công trình: " + item.tenCongTrinh}
                                  </div>
                                  {item.diaDiemCongTrinh &&
                                    <div className="ant-card-meta-description">
                                      {"Địa chỉ: " + item.diaDiemCongTrinh}
                                    </div>}
                                  {/* <div className="ant-card-meta-description">
                                {"Ngày ký: " + moment(item.ngayKy).format("DD-MM-YYYY")}
                              </div> */}
                                </div>
                                <Tooltip placement="top" title="Xem file" className="ant-card-meta-description">
                                  <CustomIcon
                                    color="#63c2de"
                                    type="file-pdf"
                                    onClick={() => { item.files && this.showFile(item.files) }}
                                    style={{ padding: "5px 10px 0 2px" }}
                                  />
                                </Tooltip>
                                <Status value={item.ngayKTHieuLuc} trangthai={item.trangThai} />
                                {item.list_BCDK.length > 0 &&
                                  <Collapse bordered={false}>
                                    <Panel header={typo.cscore_ds_bcdk}>
                                      {item.list_BCDK.map((v, idx) => {
                                        return <Row>
                                          <Col xs={24} md={16}>
                                            <div style={{ padding: "10px" }}>
                                              <div style={{ margin: "0 0 8px 20px" }}>
                                                <div onClick={() => this.GetDoanhNgiep_BaoCao(v.id)}>
                                                  {window.innerWidth < 500 ?
                                                    <div className="ant-card-meta-title" style={{ fontSize: "14px" }}>
                                                      <a>{"Đợt báo cáo: " + v.dotBaoCao}</a>
                                                      <div><a>{"Kỳ báo cáo: " + v.namBaoCao}</a></div>
                                                    </div>
                                                    :
                                                    <div className="ant-card-meta-title" style={{ fontSize: "14px" }}>
                                                      <a>{"Đợt báo cáo: " + v.dotBaoCao + ", " + "Kỳ báo cáo: " + v.namBaoCao}</a>
                                                    </div>
                                                  }

                                                  <div className="ant-card-meta-description" style={{ fontSize: "13px" }}>
                                                    {"Số báo cáo: " + v.maBaoCao}
                                                  </div>
                                                  <div className="ant-card-meta-description" style={{ fontSize: "13px" }}>
                                                    {"Tên báo cáo: " + v.tenBaoCao}
                                                  </div>
                                                </div>
                                                <Tooltip placement="top" title="Xem file" className="ant-card-meta-description">
                                                  <CustomIcon
                                                    color="#63c2de"
                                                    type="file-pdf"
                                                    onClick={() => { v.fileDinhKems && this.showFile(v.fileDinhKems) }}
                                                    style={{ padding: "5px 2px 0 2px" }}
                                                  />
                                                </Tooltip>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      })}
                                    </Panel>
                                  </Collapse>}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      }
                      )}
                    </Panel>
                  </Collapse>
                  <hr />
                  <Row className="mt-20" />
                </div>}
            </Row>
            {isShowEditDTMModal &&
              <Modal
                title={typo.cscore_edit_bao_cao}
                centered
                closable={true}
                visible={isShowEditDTMModal}
                width="750px"
                footer={null}
                onCancel={this.handleCancel}
                maskClosable={false}
              >
                <BCDKModal
                  handleAdd={this.handleCancel}
                  handleCloseModal={this.handleCancel}
                  selectedRow={selectedRow}
                  isEdit={true}
                  user={user}
                />
              </Modal>
            }
            {isShowEditBVMTModal &&
              <Modal
                title={typo.cscore_edit_bao_cao}
                centered
                closable={true}
                visible={isShowEditBVMTModal}
                width="750px"
                footer={null}
                onCancel={this.handleCancel}
                maskClosable={false}
              >
                <BCDKBVMTModal
                  handleAdd={this.handleCancel}
                  handleCloseModal={this.handleCancel}
                  selectedRow={selectedRow}
                  isEdit={true}
                  user={user}
                />
              </Modal>
            }
            {isShowEditQDXPModal &&
              <Modal
                title={typo.cscore_edit_thanh_tra}
                centered
                closable={true}
                visible={isShowEditQDXPModal}
                width="900px"
                footer={null}
                onCancel={this.handleCancel}
                maskClosable={false}
              >
                <EditOrAddModal
                  handleAdd={this.handleCancel}
                  handleCloseModal={this.handleCancel}
                  selectedRow={selectedRow}
                  isEdit={true}
                  user={user}
                />
              </Modal>
            }
            {isShowEditTNNModal &&
              <Modal
                title={typo.cscore_edit_bao_cao}
                centered
                closable={true}
                visible={isShowEditTNNModal}
                width="750px"
                footer={null}
                onCancel={this.handleCancel}
                maskClosable={false}
              >
                <DNBCTNNModal
                  handleAdd={this.handleCancel}
                  handleCloseModal={this.handleCancel}
                  selectedRow={selectedRow}
                  isEdit={true}
                  user={user}
                />
              </Modal>
            }
          </div>
        </Container>
      </PageWrapper>

    )
  };
}
TimKiemDoanhNghiep.propTypes = {

};
const mapStateToProps = (state) => ({
  user: state.oidc.user,
  functions: state.functions
});

export default connect(mapStateToProps)(TimKiemDoanhNghiep);

